<template>
    <div
        data-test-id="health-check-frequencies-cell"
        class="health-check-frequencies-cell"
    >
        <span data-test-id="frequency-set-id">{{ row.frequency_set_id }}</span>
        <a
            v-if="row.frequencies.length > 0"
            href="#"
            class="icon-view"
            data-test-id="view-frequency-set"
            @click.prevent="clickedFrequencySet"
        ></a>
    </div>
</template>

<script>
import { isNumber } from 'lodash'
import { closeModal, openModal } from 'jenesius-vue-modal'
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import TextScrollerModal from '@/components/Modal/TextScrollerModal.vue'

export default {
    mixins: [canToast, needsOrganizationSlug],
    props: ['row'],

    methods: {
        clickedFrequencySet() {
            let dataChannelsText = ''
            let controlChannelsText = ''
            this.row.frequencies.forEach((f) => {
                const mhzDisplay = this.hzToMhzPretty(f.frequency_in_hz)
                const rssi = isNumber(f.rssi) ? `${f.rssi} dBm` : 'Unknown'
                if (!f.control_channel) {
                    dataChannelsText += `${mhzDisplay} : ${rssi}\n`
                } else {
                    controlChannelsText += `${mhzDisplay} : ${rssi}\n`
                }
            })

            openModal(
                TextScrollerModal,
                {
                    label: `Freq Set ${this.row.frequency_set_id ?? ''}`,
                    text: `Control Channels\n${controlChannelsText}\nData Channels\n${dataChannelsText}`,
                    confirm: () => {
                        closeModal()
                    },
                    cancel: () => {
                        closeModal()
                    },
                },
                { backgroundClose: true }
            )
        },

        /**
         * Convert a hz value to mhz, with 5 digits after the decimal
         * place - truncated, not rounded.
         *
         * @param value
         * @returns {string}
         */
        hzToMhzPretty(value) {
            if (!isNumber(value)) {
                return 'Unknown'
            }

            const mHz = value / 1000000
            const mHzTruncated = Math.trunc(mHz * 100000) / 100000
            const mHzPadded = mHzTruncated.toFixed(5)
            return `${mHzPadded} MHz`
        },
    },
}
</script>
<style lang="scss" scoped>
a {
    text-decoration: none;
}
</style>
